(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cus-faq-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // --- Tab Logic ---
    const tabItems = document.querySelectorAll('.faq-tab-item');
    const tabContents = document.querySelectorAll('.faq-tab-content');

    tabItems.forEach(item => {
      item.addEventListener('click', function() {
        // Remove active class from all tabs and contents
        tabItems.forEach(tab => tab.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));

        // Add active class to clicked tab and target content
        this.classList.add('active');
        const targetContent = document.querySelector(this.dataset.target);
        targetContent.classList.add('active');
      });
    });

    // --- Accordion Logic ---
    const accordionHeaders = document.querySelectorAll('.faq-accordion-header');

    accordionHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const body = this.nextElementSibling;
        
        // Toggle active class on header
        this.classList.toggle('active');

        // Toggle max-height for smooth opening/closing
        if (header.classList.contains('active')) {
          body.style.maxHeight = body.scrollHeight + "px";
        } else {
          body.style.maxHeight = 0;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // --- Tab Logic ---
    const tabItems = document.querySelectorAll('.faq-tab-item');
    const tabContents = document.querySelectorAll('.faq-tab-content');

    tabItems.forEach(item => {
      item.addEventListener('click', function() {
        // Remove active class from all tabs and contents
        tabItems.forEach(tab => tab.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));

        // Add active class to clicked tab and target content
        this.classList.add('active');
        const targetContent = document.querySelector(this.dataset.target);
        targetContent.classList.add('active');
      });
    });

    // --- Accordion Logic ---
    const accordionHeaders = document.querySelectorAll('.faq-accordion-header');

    accordionHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const body = this.nextElementSibling;
        
        // Toggle active class on header
        this.classList.toggle('active');

        // Toggle max-height for smooth opening/closing
        if (header.classList.contains('active')) {
          body.style.maxHeight = body.scrollHeight + "px";
        } else {
          body.style.maxHeight = 0;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
